import React from "react";
import { Link } from "@reach/router";
import Loader from "../../components/basic/Loader";
import SonicboxLogoPNG from "../../images/sonicbox-logo.png";
import { T } from "../../hooks/useLanguage";

export default function EntryFlowGate({
  title = "home.welcome",
  error = null,
  targetPath = null,
}) {
  return (
    <div
      className="container index-page entry-flow-gate"
    >
      <img src={SonicboxLogoPNG} alt="Sonicbox logo" className="page-logo" />
      {error ? (
        <>
          <h1 style={{ color: "red" }}>
            <T>home.redeemerror</T>
          </h1>
          <p>{error.message}</p>
          {targetPath && (
            <Link to={targetPath} className="button as-link success">
              <T>sonicbox.gotoradio</T>
            </Link>
          )}
        </>
      ) : (
        <>
          <h1>
            <T>{title}</T>
          </h1>
          <Loader />
        </>
      )}
    </div>
  );
}
